import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const CDN = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function CDN({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M9.21823 4.39344C11.2758 3.87891 13.4023 4.77624 14.5571 6.5686C15.711 6.33735 16.9166 6.60145 17.8896 7.31948L17.8966 7.32474C18.826 8.02761 19.451 9.0797 19.6339 10.254C21.4361 10.4946 22.75 12.1411 22.75 13.9984C22.75 16.0259 21.1694 17.7499 19.1525 17.7499H18.9025C18.6264 17.7499 18.4025 17.526 18.4025 17.2499V16.7499C18.4025 16.4738 18.6264 16.2499 18.9025 16.2499H19.1525C20.2676 16.2499 21.25 15.2728 21.25 13.9984C21.25 12.7076 20.2761 11.7238 19.1765 11.7238H18.1896V10.9738C18.1896 9.98202 17.7299 9.08105 16.9953 8.5238C16.2474 7.97357 15.3021 7.84036 14.4509 8.1524L13.8147 8.38565L13.5183 7.77625C12.7654 6.22806 11.1198 5.4641 9.58213 5.84863C8.03644 6.23516 6.8749 7.72124 6.8749 9.47208V10.4126L5.99763 10.2616C4.99962 10.0897 3.97167 10.5222 3.31773 11.4087C2.68949 12.3177 2.57506 13.5111 3.01237 14.5186C3.47615 15.5329 4.42734 16.1937 5.43146 16.2511L5.68105 16.2654C5.95674 16.2811 6.16747 16.5174 6.15171 16.7931L6.12319 17.2923C6.10744 17.568 5.87118 17.7787 5.59548 17.7629L5.34589 17.7487C3.74109 17.657 2.31998 16.6188 1.64463 15.1345L1.63986 15.1238C0.990664 13.6358 1.15962 11.8845 2.09161 10.5445L2.09695 10.5369L2.10247 10.5293C2.89733 9.44514 4.11687 8.76943 5.42659 8.72623C5.71693 6.64475 7.20387 4.89717 9.21823 4.39344Z'
        fill={color}
      />
      <path
        d='M7.3712 11.75C7.3712 11.4739 7.59506 11.25 7.8712 11.25H13.5003C13.7764 11.25 14.0003 11.4739 14.0003 11.75V12.25C14.0003 12.5261 13.7764 12.75 13.5003 12.75H7.8712C7.59506 12.75 7.3712 12.5261 7.3712 12.25V11.75Z'
        fill={color}
      />
      <path
        d='M15.0003 11.75C15.0003 11.4739 15.2241 11.25 15.5003 11.25H16.5003C16.7764 11.25 17.0003 11.4739 17.0003 11.75V12.25C17.0003 12.5261 16.7764 12.75 16.5003 12.75H15.5003C15.2241 12.75 15.0003 12.5261 15.0003 12.25V11.75Z'
        fill={color}
      />
      <path
        d='M7.43429 14.75C7.43429 14.4739 7.65815 14.25 7.93429 14.25H13.5003C13.7764 14.25 14.0003 14.4739 14.0003 14.75V15.25C14.0003 15.5261 13.7764 15.75 13.5003 15.75H7.93429C7.65815 15.75 7.43429 15.5261 7.43429 15.25V14.75Z'
        fill={color}
      />
      <path
        d='M15.0003 14.75C15.0003 14.4739 15.2241 14.25 15.5003 14.25H16.5003C16.7764 14.25 17.0003 14.4739 17.0003 14.75V15.25C17.0003 15.5261 16.7764 15.75 16.5003 15.75H15.5003C15.2241 15.75 15.0003 15.5261 15.0003 15.25V14.75Z'
        fill={color}
      />
      <path
        d='M7.88187 17.25C7.60573 17.25 7.38187 17.4739 7.38187 17.75V18.25C7.38187 18.5261 7.60573 18.75 7.88187 18.75H13.5003C13.7764 18.75 14.0003 18.5261 14.0003 18.25V17.75C14.0003 17.4739 13.7764 17.25 13.5003 17.25H7.88187Z'
        fill={color}
      />
      <path
        d='M15.5003 17.25C15.2241 17.25 15.0003 17.4739 15.0003 17.75V18.25C15.0003 18.5261 15.2241 18.75 15.5003 18.75H16.5003C16.7764 18.75 17.0003 18.5261 17.0003 18.25V17.75C17.0003 17.4739 16.7764 17.25 16.5003 17.25H15.5003Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'cdn-icon-svg'} iconRender={iconRender} {...props} />;
});

export default CDN;
